// extracted by mini-css-extract-plugin
export var addressFields = "_o5-0";
export var animationContainer = "_o5-1";
export var footer = "_o5-2";
export var lineItems = "_o5-3";
export var modalContent = "_o5-4";
export var orderName = "_o5-5";
export var strong = "_o5-6";
export var warning = "_o5-7";